// courseStatus.ts
// Single source of truth for mapping the backend course `status` string onto the
// label shown in the UI. Backend/runtime statuses seen across the codebase:
//   draft | pending | active | published | inactive | rejected | archived
// Note: `active` and `published` are both "live/visible to learners" — the
// governance approve step now sets `active`, but legacy courses may be
// `published`, so both map to the same "Active" label.
export type CourseDisplayStatus =
  | 'Active'
  | 'Inactive'
  | 'Draft'
  | 'Pending'
  | 'Rejected'
  | 'Archived';

export const mapApiCourseStatus = (
  apiStatus?: string | null
): CourseDisplayStatus => {
  switch ((apiStatus || '').toLowerCase()) {
    case 'active':
    case 'published':
      return 'Active';
    case 'inactive':
      return 'Inactive';
    case 'draft':
      return 'Draft';
    case 'rejected':
      return 'Rejected';
    case 'archived':
      return 'Archived';
    case 'pending':
    default:
      return 'Pending';
  }
};
